module.exports = __webpack_public_path__ + "static/media/calendar.0237a43c.svg";